var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13770",
    "data-name": "Group 13770",
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.089,
    height: 105.071,
    viewBox: "0 0 155.089 105.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M127.449,711l-33.779,3.422L70.9,759.553c18,0,27.251-1.75,37.78-16.755A316.442,316.442,0,0,0,127.449,711",
    transform: "translate(-66.241 -664.211)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M641.372,5.028,643.958,0H572.952c-24.072,0-36.359,8.14-43.828,23.224-5.844,11.8-5.824,11.806-5.824,11.806h32.252c11.47-21.96,25.441-29.534,59.615-30Z",
    transform: "translate(-488.869)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M1428.013,150c-43.3.375-50.5,7.43-60.313,25.158l47.908.02Z",
    transform: "translate(-1277.701 -140.129)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M104.5,660.235a39,39,0,0,1-31.39,31.417,117.971,117.971,0,0,1-15.827,1.678c-6.271.007-57.187,0-57.187,0l2.2-4.495s19.367-.151,21.967-.151c6.679.151,18.775-1.31,18.775-1.31,13.655-1.441,24.4-10.338,27.817-23.276l3.843-13.05a23.508,23.508,0,0,1,23.072-19.005l37.05-2.343-1.77,3.547-11.418.7a17.8,17.8,0,0,0-16.248,15.7Z",
    transform: "translate(-0.1 -588.261)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFsWhite);
export default __webpack_public_path__ + "static/media/logoFS_white.24d12567cc6b0796f2c1394293e69243.svg";
export { ForwardRef as ReactComponent };